import service from '@/services'
import * as types from '../mutation-type'

// state
const state = {
}

// getters
const getters = {
}

// actions
const actions = {
  getProvince: ({commit, rootState}, payload) => {
    // let key = 'province_info'
    // let data = rootState.commonData[key]
    // // console.log(data, state.commonData, rootState)
    // if (data) {
    //   return service.dataCommit(commit, data).then(() => {
    //     return data
    //   })
    // }
    // return service.getProvince(commit, payload).then(data => {
    //   return service.dataCommit(commit, {key: key, value: data.dtoList}, types.COMMIT_PURE_DATA)
    // })
    return service.getProvince(commit, payload)
  },
  getCity: ({commit, rootState}, payload) => {
    let key = `city_${payload.id || payload}`
    // console.log(state)
    // let data = rootState.commonData[key]
    // if (data) {
    //   return service.dataCommit(commit, data).then(() => {
    //     return data
    //   })
    // }
    return service.getCity(commit, payload).then(data => {
      return service.dataCommit(commit, {key: key, value: data.dtoList}, types.COMMIT_PURE_DATA)
    })
  },
  getDistrict: ({commit, rootState}, payload) => {
    let key = `district_${payload.id || payload}`
    // let data = rootState.commonData[key]
    // if (data) {
    //   return service.dataCommit(commit, data).then(() => {
    //     return data
    //   })
    // }
    return service.getDistrict(commit, payload).then(data => {
      return service.dataCommit(commit, {key: key, value: data.dtoList}, types.COMMIT_PURE_DATA)
    })
  },
  getBankInfoByBankAccount: ({commit}, payload) => {
    return service.getBankInfoByBankAccount(commit, payload)
  },
  getBatchBankInfoByCode: ({commit}, payload) => {
    return service.getBatchBankInfoByCode(commit, payload)
  }
}

// mutations
const mutations = {

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js